import { render, staticRenderFns } from "./SingleAnswerMatrix.vue?vue&type=template&id=45033902&"
import script from "./SingleAnswerMatrix.vue?vue&type=script&lang=js&"
export * from "./SingleAnswerMatrix.vue?vue&type=script&lang=js&"
import style0 from "./SingleAnswerMatrix.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports